import React from "react";
import styles from "../styles.module.css";
import { formatCurrency } from "../../../../../utils/currency";

const PaymentsModal = ({ data, setPaymentsModal }) => {


  const teacherName = data?.teacherId?.userId?.fullName ||
    (data?.teacherId?.firstName?.data
      ? `${data.teacherId.firstName.data} ${data.teacherId.lastName?.data || ""}`
      : "Teacher");

  const studentName = data?.studentId?.fullName || "Student";
  const totalAmount = Number(data?.totalAfterDiscount || data?.total || data?.itemPrice || 0);

  return (
    <div className={styles.modalBackdrop}>
      <div
        className={styles.modal}
        style={{ width: "750px" }}>
        <div className={styles.modal_header}>
          <h1>Transaction Details</h1>
          <i
            className={styles.closeBtn + " fas fa-close"}
            onClick={() => {
              setPaymentsModal(false);
            }}></i>
        </div>

        <div className={styles.modal_body} style={{ overflowY: "auto", maxHeight: "calc(90vh - 120px)", paddingRight: "10px" }}>
          <div className={styles.detail_row}>
            <h3>Transaction ID</h3>
            <h3>{data?._id || "-"}</h3>
          </div>

          <div className={styles.detail_row}>
            <h3>Course Name</h3>
            <h3>{data?.courseId?.title?.data || data?.courseId?.title || "-"}</h3>
          </div>

          <div className={styles.detail_row}>
            <h3>Student Name</h3>
            <h3>{studentName}</h3>
          </div>

          <div className={styles.detail_row}>
            <h3>Teacher Name</h3>
            <h3>{teacherName}</h3>
          </div>

          <div style={{ margin: "1.5rem 0", padding: "1.25rem", backgroundColor: "#eff6ff", borderRadius: "16px", border: "1px solid #dbeafe" }}>
            <div className={styles.detail_row} style={{ backgroundColor: "transparent", padding: 0, marginBottom: "1rem" }}>
              <h3 style={{ fontSize: "1rem" }}>Paid Amount</h3>
              <h3 style={{ fontSize: "1.2rem", color: "#1e40af" }}>{formatCurrency(totalAmount)}</h3>
            </div>
            {data?.platformFees > 0 && (
              <div className={styles.detail_row} style={{ backgroundColor: "transparent", padding: 0, marginBottom: 0 }}>
                <h3 style={{ fontSize: "0.9rem", color: "#64748b" }}>Platform Fee (Neurolingua share)</h3>
                <h3 style={{ color: "#ef4444" }}>- {formatCurrency(data.platformFees)}</h3>
              </div>
            )}
          </div>

          {data?.couponUsed && (
            <div style={{ marginBottom: "1.5rem" }}>
              <div className={styles.detail_row}>
                <h3>Coupon applied</h3>
                <h3 style={{ color: "#059669", backgroundColor: "#ecfdf5", padding: "4px 12px", borderRadius: "20px" }}>{data?.couponName || "Discount"}</h3>
              </div>
              <div className={styles.detail_row}>
                <h3>Discount value</h3>
                <h3>{data?.couponDiscount}%</h3>
              </div>
            </div>
          )}

          {data?.razorpay_payment_id && (
            <div style={{ borderTop: "1px solid #f1f5f9", paddingTop: "1.5rem" }}>
              <div className={styles.detail_row}>
                <h3>Payment Gateway ID</h3>
                <h3 style={{ fontSize: "0.85rem", opacity: 0.8 }}>{data?.razorpay_payment_id}</h3>
              </div>
              <div className={styles.detail_row}>
                <h3>Order ID</h3>
                <h3 style={{ fontSize: "0.85rem", opacity: 0.8 }}>{data?.razorpay_order_id}</h3>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentsModal;
